var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mb-4 detail-container', { sm: _vm.sm }]},[_c('div',{staticClass:"detail-container-title"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("actions")],2)]),_c('div',{staticClass:"detail-container-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }